import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import {
  BaSeContainer,
  BaSeDatePicker,
  BaSeGrid,
  BaSeGridItem,
  BaSeSelect,
  BaSeLoading,
  BaSeTheme,
  BaSeOptionPicker,
  BaSeButton,
  BaSeSmall1,
  BaSeTag,
  BaSeMessage,
  BaSeDialogContext,
  BaSeBreakpointContext,
  BaSeHeading5,
  BaSeParagraph,
  BaSeShapeButton,
} from '@base/react';
import {
  add,
  sub,
  isAfter,
  isBefore,
  isFirstDayOfMonth,
  isLastDayOfMonth,
  format,
  differenceInDays,
} from 'date-fns';
import { AppContext } from '../../components/shared/context';
import { Jumbotron } from '../../components/shared/jumbotron/jumbotron';
import {
  ActivatedFilters,
  ContentContainer,
  NoPrint,
  WrapperActivatedFilters,
} from './new-relatorios-styled';
import {
  listFilterSituacao,
  useRelatorio,
  useRepportService,
} from '../../services/relatorio/RelatorioService';
import {
  months,
  relatorioDateOptions,
} from '../../components/shared/utils/months';
import {
  useGetListaContas,
  useGetListaContatos,
  useGetListaFiltrosPredefinidos,
} from '../../services/gerenciar-conta/GerenciarContaService.js';
import { useCategoria } from '../../services/categoria/CategoriaService.js';
import { RelatoriosMei } from './relatorios-mei.jsx';
import { isEmpresaMei } from '../../components/shared/utils/empresa/empresa-util.js';
import { RelatoriosLancamentos } from './relatorios-lancamentos.jsx';
import { RelatorioDiarioLista } from '../../components/new-relatorios/diario/relatorio-diario-lista.jsx';
import { RelatorioExtratoLista } from '../../components/new-relatorios/extrato/relatorio-extrato-lista';
import { RelatorioFluxoLista } from '../../components/new-relatorios/fluxo/relatorio-fluxo-lista';
import EmptyData from '../../images/not-found.svg';
import ExcluirGrid from '../../components/shared/modal/excluir-grid/index.js';
import modalActions from '../../constants/acoesModal.js';
import { FiltrosPredefinidos } from './filtros-predefinidos.jsx';
import { enumRelatorios } from '../../constants/relatorions.js';
import { v2 } from '../../constants/endpoints.js';

const formatdate = (date) => format(date, 'yyyy-MM-dd');

export const makeArrayFromObj = (obj) => {
  if (!obj) {
    return;
  }
  let size = 0;
  const arr = [];
  for (let ob in obj) {
    arr[size] = obj[ob];
    size++;
  }
  return arr;
};

const DEFAULT_SELECTED_ID = 2;

const SelectListTypeReport = ({
  label,
  callBack,
  setTypeReport,
  listReport,
  values,
}) => (
  <BaSeOptionPicker
    withFilterText={false}
    color="default"
    emptyValueLabel={label}
    size="small"
    onChange={(e) => callBack(setTypeReport, e, label)}
    values={values}
    initialSelectedValuesId={listReport?.map((item) => item?.id)}
  />
);

// eslint-disable-next-line
const NewRelatoriosPage = () => {
  const {
    buscarRelatorioLancamentoPorDia,
    buscarRelatorioLancamentoPorExtrato,
    buscarRelatorioLancamentoPorFluxo,
    downloadRelatorioDia,
    downloadRelatorioExtrato,
    downloadRelatorioFluxo,
    getFiltrosPredefinidos,
    relatorioDasn,
    relatorioMensalMei,
    relatorioDasnDownload,
    relatorioMensalMeiDownload,
    relatorioContato,
    relatorioConta,
    relatorioCategoria,
  } = useRelatorio();
  const { tiposRelatorios, anos, meses, tiposLancamento } = useRepportService();
  const { empresa, empresaCpe } = React.useContext(AppContext);
  const { listaContas } = useGetListaContas(empresa?.id);
  const { listaContatos } = useGetListaContatos(empresa?.id);
  const { listaFiltrosPredefinidos } = useGetListaFiltrosPredefinidos(
    empresa?.id,
  );
  const { backendDelete } = Sebrae.useBackend();
  const { buscarCategoriaReceita, buscarCategoriaDespesa } = useCategoria();
  const { showNotification, showModal } = React.useContext(BaSeDialogContext);
  const { inTablet } = React.useContext(BaSeBreakpointContext);
  const [selectOptions] = React.useState(relatorioDateOptions());
  const [mesFiltro, setMesFiltro] = React.useState(
    selectOptions[DEFAULT_SELECTED_ID],
  );
  const [startDate, setStartDate] = React.useState(
    selectOptions[DEFAULT_SELECTED_ID]?.init,
  );
  const [endDate, setEndDate] = React.useState(
    selectOptions[DEFAULT_SELECTED_ID]?.end,
  );

  const [dadosDiario, setDadosDiario] = React.useState(null);
  const [dadosExtrato, setDadosExtrato] = React.useState(null);
  const [dadosFluxo, setDadosFluxo] = React.useState(null);
  //Novo filtro de relatórios
  const [tipoRelatorio, setTipoRelatorio] = React.useState('');
  const [filtroAnos, setFiltroAnos] = React.useState(0);
  const [filtroMeses, setFiltroMeses] = React.useState(0);
  const [situacaoSelected, setSituacaoSelected] = React.useState([]);
  const [tiposLancamentoSelected, setTiposLancamentoSelected] = React.useState(
    [],
  );
  const [categoriasSelected, setCategoriasSelected] = React.useState([]);
  const [subCategoriasSelected, setSubcategoriasSelected] = React.useState([]);
  const [isTagsVisible, setIsTagsVisible] = React.useState(true);
  const [tags, setTags] = React.useState([]);
  const [listaReceitas, setListaReceitas] = React.useState([]);
  const [listaDespesas, setListaDespesas] = React.useState([]);
  const [listaTiposRelatorio, setListaTiposRelatorio] = React.useState([]);
  const [listaSubcategorias, setListaSubcategorias] = React.useState([]);
  const [showRelatorio, setShowRelatorio] = React.useState('');
  const [paramsFilter, setParamsFilter] = React.useState([]);
  const [error, setError] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const [listaConta, setListaConta] = React.useState([]);
  const [listaContato, setListaContato] = React.useState([]);
  const [filtrosPredefinidos, setFiltrosPredefinidos] = React.useState(
    listaFiltrosPredefinidos,
  );
  const [filtrosPredefinidoPorTipo, setFiltrosPredefinidoPorTipo] =
    React.useState([]);
  const [filtroPredefinidoSelected, setfiltroPredefinidoSelected] =
    React.useState([]);
  const [isSucces, setIsSucces] = React.useState(false);
  //Indicador para atualizar lista de filtros predefinidos
  const [isAtualizaFiltrosPredefinidos, setIsAtualizaFiltrosPredefinidos] =
    React.useState(false);

  const typeReport = React.useMemo(
    () => ({
      DIARIO: 'Diário',
      EXTRATO: 'Extrato',
      FLUXO: 'Fluxo de caixa',
      DASNMEI: 'Relatório DASN MEI',
      MENSALMEI: 'Relatório Mensal MEI',
      CONTATO: 'Relatório por contato',
      CATEGORIA: 'Relatório por categoria',
      CONTA: 'Relatório por conta',
    }),
    [],
  );

  const isDiario = React.useMemo(
    () => tipoRelatorio === typeReport.DIARIO,
    [tipoRelatorio, typeReport],
  );

  const isExtrato = React.useMemo(
    () => tipoRelatorio === typeReport.EXTRATO,
    [tipoRelatorio, typeReport],
  );

  const isFluxo = React.useMemo(
    () => tipoRelatorio === typeReport.FLUXO,
    [tipoRelatorio, typeReport],
  );

  const isContato = React.useMemo(
    () => tipoRelatorio === typeReport.CONTATO,
    [tipoRelatorio, typeReport],
  );

  const isConta = React.useMemo(
    () => tipoRelatorio === typeReport.CONTA,
    [tipoRelatorio, typeReport],
  );

  const isCategoria = React.useMemo(
    () => tipoRelatorio === typeReport.CATEGORIA,
    [tipoRelatorio, typeReport],
  );

  const isAllFilters = React.useMemo(
    () =>
      isDiario || isExtrato || isFluxo || isConta || isContato || isCategoria,
    [isDiario, isExtrato, isFluxo, isConta, isContato, isCategoria],
  );

  const isDiarioExtratoFluxo = React.useMemo(
    () => isDiario || isExtrato || isFluxo,
    [isDiario, isExtrato, isFluxo],
  );

  const resetList = React.useCallback(() => {
    setIsAtualizaFiltrosPredefinidos((curr) => {
      if (curr) {
        setfiltroPredefinidoSelected([]);
        return false;
      }
      return curr;
    });
  }, []);

  const handleChangeMonth = React.useCallback(
    (value) => {
      if (value?.toCustom) {
        setMesFiltro({ id: 7, label: 'Personalizado' }); // resetando select para a opção "Personalizado"
        setTimeout(() => resetList(), 500);

        return;
      }
      if (!value?.id || value?.id === 7) {
        // verifica se o mesmo é "personalizado"
        setMesFiltro(value);
        setTimeout(() => resetList(), 500);

        return;
      }
      setMesFiltro(value);
      setStartDate(value?.init);
      setEndDate(value?.end);
      setTimeout(() => resetList(), 500);
    },
    [resetList],
  );

  const updateProperSelection = React.useCallback(
    (method, value) => {
      handleChangeMonth({ toCustom: true }); // reseta o select do período do relatório quando ouver seleção do usuário em algum datepicker
      return method(value);
    },
    [handleChangeMonth],
  );

  const [loading, setLoading] = React.useState();
  const [dadosRelatorioMei, setDadosRelatorioMei] = React.useState(null);
  const [dadosRelatorioLancamento, setDadosRelatorioLancamento] =
    React.useState(null);

  const [blobPdf, setBlobPdf] = React.useState(null);
  const [loadingDownload, setLoadingDownload] = React.useState(false);

  const downloadRef = React.useRef(null);

  const getSelectCorrectId = React.useCallback(
    (opt, df) => {
      return mesFiltro?.[opt] ?? df;
    },
    [mesFiltro],
  );

  const messageError = React.useCallback(
    (error, title) => {
      setError(true);
      showNotification({
        message: `Não foi possível ${title} o relatório`,
        supportMessage: error?.message ?? '',
        color: 'destructive',
      });
    },
    [showNotification],
  );

  const downloadRelatorio = React.useCallback(
    (getDownload, empresa, date1, date2) => {
      setLoadingDownload(true);
      getDownload(empresa, date1, date2)
        .then((data) => {
          setBlobPdf(window.URL.createObjectURL(data));
          setShowRelatorio(
            isDiario
              ? typeReport.DIARIO
              : isExtrato
              ? typeReport.EXTRATO
              : typeReport.FLUXO,
          );
          setTimeout(() => {
            downloadRef.current.click();
          });
        })
        .catch((error) => messageError(error, 'exportar'))
        .finally(() => {
          setLoadingDownload(false);
        });
    },
    [isDiario, isExtrato, messageError, typeReport],
  );

  const handleClearFilters = React.useCallback(() => {
    setSituacaoSelected([]);
    setTiposLancamentoSelected([]);
    setCategoriasSelected([]);
    setSubcategoriasSelected([]);
    setTags([]);
    setDadosRelatorioLancamento(null);
    setListaConta([]);
    setListaContato([]);
    setfiltroPredefinidoSelected([]);
  }, []);

  const handleCategorias = React.useCallback(() => {
    const listaCategorias = [];
    tiposLancamentoSelected.map((item) => {
      if (item?.label === 'Receitas') {
        return listaCategorias.push(...listaReceitas);
      }
      if (item?.label === 'Despesas') {
        return listaCategorias.push(...listaDespesas);
      }
      return false;
    });

    return listaCategorias;
  }, [listaDespesas, listaReceitas, tiposLancamentoSelected]);

  const handleFiltros = React.useCallback(
    (func, values, titleTag) => {
      func(values);
      const filtros = {
        Categoria: handleCategorias(),
        Situação: listFilterSituacao,
        Subcategoria: listaSubcategorias,
        'Tipo de lançamento': tiposLancamento,
        Conta: listaContas,
        Contato: listaContatos,
        default: [],
      };
      const tagAtiva = values?.length
        ? {
            title: titleTag,
            values: values,
            todos: filtros?.[titleTag ?? 'default']?.length === values?.length,
          }
        : null;

      setTags((tagsCurr) => {
        let oldTags = tagsCurr?.length
          ? tagsCurr?.filter((item) => item?.title !== titleTag)
          : tagsCurr;
        if (tagAtiva) {
          return [...oldTags, tagAtiva];
        }
        return oldTags;
      });
      if (isAtualizaFiltrosPredefinidos) {
        setfiltroPredefinidoSelected([]);
      }
    },
    [
      handleCategorias,
      isAtualizaFiltrosPredefinidos,
      listaContas,
      listaContatos,
      listaSubcategorias,
      tiposLancamento,
    ],
  );

  const handleRemoveTag = React.useCallback(
    (item) => {
      setfiltroPredefinidoSelected([]);
      const filtros = {
        Categoria: setCategoriasSelected,
        Situação: setSituacaoSelected,
        Subcategoria: setSubcategoriasSelected,
        'Tipo de lançamento': setTiposLancamentoSelected,
        Conta: setListaConta,
        Contato: setListaContato,
      };
      if (item?.todos) {
        return filtros?.[item.title]?.([]);
      }
      const tagEncontrada = tags.find((tag) =>
        tag?.values.find(
          (value) => value.id === item.id && value.label === item.label,
        ),
      );

      const func = filtros[tagEncontrada?.title];
      func &&
        func((curr) => {
          return curr?.filter((value) => value.id !== item.id);
        });
    },
    [tags],
  );

  const updateListaFiltros = React.useCallback(async () => {
    await getFiltrosPredefinidos(empresa.id)
      .then((data) => {
        const filters = data?.map((e) => ({
          ...e,
          label: e?.nome,
        }));
        setFiltrosPredefinidos(filters);
        handleClearFilters();
      })
      .catch((error) => {
        showNotification({
          message: 'Não foi possível recuperar lista de filtros predefinidos!',
          color: 'destructive',
          supportMessage: error?.message ?? '',
        });
      });
  }, [
    empresa.id,
    getFiltrosPredefinidos,
    handleClearFilters,
    showNotification,
  ]);

  React.useEffect(() => {
    if (isSucces) {
      updateListaFiltros();
      setIsSucces(false);
    }
  }, [isSucces, updateListaFiltros]);

  const changeId = React.useCallback((values) => {
    if (!values.length) return values;
    return values.map((item) => item?.id);
  }, []);

  const handleNewFilterPredifined = React.useCallback(() => {
    const filtrosLabel = {
      periodo: mesFiltro,
      dataInicio: startDate?.toLocaleDateString('pt-BR'),
      dataFim: endDate?.toLocaleDateString('pt-BR'),
      contatos: listaContato,
      conta: listaConta,
      situacao: situacaoSelected,
      tipoLancamento: tiposLancamentoSelected,
      categoria: categoriasSelected,
      subcategoria: subCategoriasSelected,
    };

    const params = {
      nome: null,
      tipoRelatorio: enumRelatorios?.[tipoRelatorio] ?? '',
      filtro: {
        periodo: mesFiltro,
        dataInicio: startDate?.toLocaleDateString('pt-BR'),
        dataFim: endDate?.toLocaleDateString('pt-BR'),
        contatos: changeId(listaContato),
        conta: changeId(listaConta),
        situacao: changeId(situacaoSelected),
        tipoLancamento: changeId(tiposLancamentoSelected),
        categoria: changeId(categoriasSelected),
        subcategoria: changeId(subCategoriasSelected),
      },
    };

    showModal({
      title: 'Salvar filtros predefinidos',
      actions: [],
      size: 'large',
      content: ({ closeModal }) => (
        <FiltrosPredefinidos
          closeModal={closeModal}
          params={params}
          filtrosLabel={filtrosLabel}
          setIsSucces={setIsSucces}
          listaFiltros={filtrosPredefinidoPorTipo}
        />
      ),
    });
  }, [
    categoriasSelected,
    changeId,
    endDate,
    filtrosPredefinidoPorTipo,
    listaConta,
    listaContato,
    mesFiltro,
    showModal,
    situacaoSelected,
    startDate,
    subCategoriasSelected,
    tipoRelatorio,
    tiposLancamentoSelected,
  ]);

  React.useEffect(() => {
    const isTag = tags?.some((item) => {
      if (item?.values?.length) {
        return true;
      }
      return false;
    });
    setIsTagsVisible(isTag);
  }, [tags]);

  const mesAnoAtual = React.useMemo(() => {
    const dataAtual = new Date();
    const mes = dataAtual.getMonth();
    const ano = dataAtual.getFullYear();

    return { mes: mes, ano: ano };
  }, []);

  const handleShowTable = React.useCallback(
    (data, child) => {
      return data ? (
        child()
      ) : (
        <div
          style={{
            display: 'grid',
            placeItems: 'center',
            gap: 24,
            textAlign: 'center',
            paddingTop: 48,
            paddingBottom: 48,
          }}
        >
          <img src={EmptyData} alt="Relatório vázio" />
          <div>
            <BaSeHeading5
              isBold
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              Nenhum lançamento encontrado.
            </BaSeHeading5>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae30}
            >
              {`Altere o período${
                isAllFilters ? ', os filtros selecionados' : ' selecionado'
              } ou realize lançamentos.`}
            </BaSeParagraph>
          </div>
        </div>
      );
    },
    [isAllFilters],
  );

  const isNotDate = React.useMemo(
    () => !startDate || !endDate,
    [endDate, startDate],
  );

  const paramsIds = React.useCallback((lista, chave) => {
    const ids = lista?.map((item) => item?.id ?? item);

    return ids.length ? ids.map((item) => `${chave}=${item}`) : null;
  }, []);

  const notfyDate = React.useCallback(() => {
    showNotification({
      message: 'Selecione uma Data de início e uma Data fim!',
      color: 'attention',
    });
  }, [showNotification]);

  // eslint-disable-next-line
  const handleVisualizarRelatorio = React.useCallback(() => {
    setError(false);
    const dataInicio = `dataInicio=${startDate?.toLocaleDateString('en-CA')}`;
    const dataFim = `dataFim=${endDate?.toLocaleDateString('en-CA')}`;
    const situacao = paramsIds(situacaoSelected, 'situacao');
    const categoria = paramsIds(categoriasSelected, 'categoria');
    const subCategoria = paramsIds(subCategoriasSelected, 'subCategoria');
    const conta = paramsIds(listaConta, 'conta');
    const contato = paramsIds(listaContato, 'contato');
    const tipoLancamento = paramsIds(tiposLancamentoSelected, 'tipoLancamento');

    let params = [dataInicio, dataFim];

    situacao?.length && params.push(...situacao);
    categoria?.length && params.push(...categoria);
    tipoLancamento?.length && params.push(...tipoLancamento);
    subCategoria?.length && params.push(...subCategoria);
    conta?.length && params.push(...conta);
    contato?.length && params.push(...contato);

    setParamsFilter(params);

    if (tipoRelatorio === typeReport.DIARIO) {
      if (isNotDate) {
        notfyDate();
        return;
      }
      setLoading(true);
      buscarRelatorioLancamentoPorDia(empresa?.cnpj, params.join('&'))
        .then(setDadosDiario)
        .finally(() => setLoading(false));
    }

    if (tipoRelatorio === typeReport.EXTRATO) {
      if (isNotDate) {
        notfyDate();
        return;
      }
      setLoading(true);
      buscarRelatorioLancamentoPorExtrato(empresa?.cnpj, params.join('&'))
        .then(setDadosExtrato)
        .finally(() => setLoading(false));
    }

    if (tipoRelatorio === typeReport.FLUXO) {
      if (isNotDate) {
        notfyDate();
        return;
      }
      setLoading(true);
      buscarRelatorioLancamentoPorFluxo(
        empresa?.cnpj,
        params.join('&'),
        differenceInDays(endDate, startDate) > 31,
      )
        .then((data) =>
          setDadosFluxo({
            ...data,
            lancamentos: makeArrayFromObj(data.lancamentos),
          }),
        )
        .finally(() => setLoading(false));
    }

    if (tipoRelatorio === typeReport.DASNMEI) {
      setLoading(true);
      relatorioDasn(empresa?.id, parseInt(filtroAnos))
        .then((data) => {
          setDadosRelatorioMei(data);
          setShowRelatorio(typeReport.DASNMEI);
          setMessage(data?.mensagem);
        })
        .catch((error) => messageError(error, 'visualizar'))
        .finally(() => setLoading(false));
      return;
    }

    if (tipoRelatorio === typeReport.MENSALMEI) {
      setLoading(true);
      relatorioMensalMei(empresa?.id, parseInt(filtroAnos), filtroMeses + 1)
        .then((data) => {
          setDadosRelatorioMei(data);
          setShowRelatorio(typeReport.MENSALMEI);
          setMessage(data?.mensagem);
        })
        .catch((error) => {
          messageError(error, 'visualizar');
          setError(true);
        })
        .finally(() => setLoading(false));
      return;
    }

    if (isContato || isConta || isCategoria) {
      if (isNotDate) {
        notfyDate();
        return;
      }

      const getRelatorio = isContato
        ? relatorioContato
        : isConta
        ? relatorioConta
        : relatorioCategoria;

      setLoading(true);
      getRelatorio(empresa?.id, params.join('&'))
        .then((data) => {
          setParamsFilter(params);
          setDadosRelatorioLancamento(data);
          setShowRelatorio(
            isContato
              ? typeReport.CONTATO
              : isConta
              ? typeReport.CONTA
              : typeReport.CATEGORIA,
          );
        })
        .catch((error) => messageError(error, 'visualizar'))
        .finally(() => setLoading(false));
    }
  }, [
    buscarRelatorioLancamentoPorDia,
    buscarRelatorioLancamentoPorExtrato,
    buscarRelatorioLancamentoPorFluxo,
    categoriasSelected,
    empresa,
    endDate,
    filtroAnos,
    filtroMeses,
    isCategoria,
    isConta,
    isContato,
    isNotDate,
    listaConta,
    listaContato,
    messageError,
    notfyDate,
    paramsIds,
    relatorioCategoria,
    relatorioConta,
    relatorioContato,
    relatorioDasn,
    relatorioMensalMei,
    situacaoSelected,
    startDate,
    subCategoriasSelected,
    tipoRelatorio,
    tiposLancamentoSelected,
    typeReport,
  ]);

  const handleTipoRelatorio = React.useCallback(
    (values) => {
      setTipoRelatorio(values?.[0]?.id ?? null);
      handleClearFilters();
    },
    [handleClearFilters],
  );

  const handleListaSubcategorias = React.useCallback(
    (values) => {
      const lista = [];
      const categorias = [...listaReceitas, ...listaDespesas];

      const subcategorias = values?.map((item) => {
        const filterSubcategorias = categorias.find(
          (e) => e.id === item?.id && e?.listaSubcategoria?.length,
        );
        return filterSubcategorias?.listaSubcategoria?.map(
          (itemSubcategoria) => {
            if (itemSubcategoria) {
              lista.push({
                id: itemSubcategoria?.id,
                label: itemSubcategoria?.descricao,
              });
            }
            return null;
          },
        );
      });

      setListaSubcategorias(lista);
      return subcategorias;
    },
    [listaDespesas, listaReceitas],
  );

  React.useEffect(() => {
    buscarCategoriaReceita(empresa).then((receitas) => {
      const categoriaReceitas = receitas?.map((item) => ({
        id: item?.id,
        label: item?.descricao,
        listaSubcategoria: item?.listaSubcategoria,
      }));
      setListaReceitas(categoriaReceitas);
    });

    buscarCategoriaDespesa(empresa).then((despesas) => {
      // eslint-disable-next-line
      const categoriaDespesas = despesas?.map((item) => ({
        id: item?.id,
        label: item?.descricao,
        listaSubcategoria: item?.listaSubcategoria,
      }));
      setListaDespesas(categoriaDespesas);
    });
  }, [anos, buscarCategoriaDespesa, buscarCategoriaReceita, empresa]);

  React.useEffect(() => {
    setTipoRelatorio('Selecione');
    if (!isEmpresaMei(empresaCpe) && tiposRelatorios) {
      const tiposSemMEI = tiposRelatorios?.filter((_, i) => i !== 4 && i !== 5); //remove opçao do tipo MEI
      setListaTiposRelatorio(tiposSemMEI);
      return;
    }
    setListaTiposRelatorio(tiposRelatorios);
  }, [empresaCpe, tiposRelatorios]);

  const tipoLancamentoFilter = React.useMemo(
    () => (
      <BaSeGridItem
        tablet={{ size: 12 }}
        desktop={{ size: isDiarioExtratoFluxo ? 2 : 3 }}
      >
        <BaSeOptionPicker
          withFilterText={false}
          color="default"
          emptyValueLabel="Tipo de lançamento"
          size="small"
          onChange={(e) => {
            handleFiltros(setTiposLancamentoSelected, e, 'Tipo de lançamento');
            if (!e?.length) {
              setCategoriasSelected([]);
              setSubcategoriasSelected([]);
            }
          }}
          values={tiposLancamento}
          initialSelectedValuesId={tiposLancamentoSelected?.map(
            (item) => item?.id,
          )}
        />
      </BaSeGridItem>
    ),
    [
      handleFiltros,
      isDiarioExtratoFluxo,
      tiposLancamento,
      tiposLancamentoSelected,
    ],
  );

  const categoriaFilter = React.useMemo(
    () => (
      <BaSeGridItem
        tablet={{ size: 12 }}
        desktop={{ size: isDiarioExtratoFluxo ? 2 : 3 }}
      >
        <BaSeOptionPicker
          withFilterText={false}
          color="default"
          emptyValueLabel="Categoria"
          size="small"
          onChange={(e) => {
            handleFiltros(setCategoriasSelected, e, 'Categoria');
            if (isCategoria) {
              if (!e?.length) setSubcategoriasSelected([]);
              handleListaSubcategorias(e);
            }
          }}
          values={handleCategorias()}
          initialSelectedValuesId={categoriasSelected?.map((item) => item?.id)}
          complement={
            tiposLancamentoSelected?.length
              ? ''
              : 'Selecione um tipo de lançamento primeiro'
          }
        />
      </BaSeGridItem>
    ),
    [
      categoriasSelected,
      handleCategorias,
      handleFiltros,
      handleListaSubcategorias,
      isCategoria,
      isDiarioExtratoFluxo,
      tiposLancamentoSelected,
    ],
  );

  const situacaoFilter = React.useMemo(
    () => (
      <BaSeGridItem tablet={{ size: 12 }} desktop={{ size: 2 }}>
        <BaSeOptionPicker
          withFilterText={false}
          color="default"
          emptyValueLabel="Situação"
          size="small"
          onChange={(e) => handleFiltros(setSituacaoSelected, e, 'Situação')}
          values={listFilterSituacao}
          initialSelectedValuesId={situacaoSelected?.map((item) => item?.id)}
        />
      </BaSeGridItem>
    ),
    [handleFiltros, situacaoSelected],
  );

  const subcategoriaFilter = React.useMemo(
    () => (
      <BaSeGridItem tablet={{ size: 12 }} desktop={{ size: 3 }}>
        <BaSeOptionPicker
          withFilterText={false}
          color="default"
          emptyValueLabel="Subcategoria"
          size="small"
          onChange={(e) =>
            handleFiltros(setSubcategoriasSelected, e, 'Subcategoria')
          }
          values={listaSubcategorias}
          initialSelectedValuesId={subCategoriasSelected?.map(
            (item) => item?.id,
          )}
          complement={
            categoriasSelected?.length ? '' : 'Selecione uma categoria primeiro'
          }
        />
      </BaSeGridItem>
    ),
    [
      categoriasSelected,
      handleFiltros,
      listaSubcategorias,
      subCategoriasSelected,
    ],
  );

  const checkDadosRelatorio = React.useCallback((value) => {
    if (value?.some((item) => item?.listaLancamentos?.length)) {
      return value;
    }
    return [];
  }, []);

  const findList = React.useCallback(
    (element, list) =>
      element?.map((item) => list.find((obj) => obj.id === item)) ?? [],
    [],
  );

  const handleChangeFilters = React.useCallback(
    (values) => {
      setIsAtualizaFiltrosPredefinidos(false);
      for (let index = 0; index < values.length; index++) {
        const filtro = values?.[index]?.filtro;
        const dataInicio = new Date(`${filtro.dataInicio}T00:00:00`);
        const dataFim = new Date(`${filtro.dataFim}T00:00:00`);
        setMesFiltro(selectOptions.find((obj) => obj.id === filtro?.periodo));
        setListaConta(findList(filtro?.conta, listaContas));
        setStartDate(dataInicio);
        setEndDate(dataFim);
        setListaContato(findList(filtro?.contato, listaContatos));
        setSituacaoSelected(findList(filtro?.situacao, listFilterSituacao));
        setTiposLancamentoSelected(
          findList(filtro?.tipoLancamento, tiposLancamento),
        );
        setCategoriasSelected(
          findList(filtro?.categoria, [...listaReceitas, ...listaDespesas]),
        );
        setSubcategoriasSelected(
          findList(filtro?.subCategoria, listaSubcategorias),
        );
        setTimeout(
          () => setIsAtualizaFiltrosPredefinidos(index + 1 === values.length),
          1500,
        );
      }
    },
    [
      findList,
      listaContas,
      listaContatos,
      listaDespesas,
      listaReceitas,
      listaSubcategorias,
      selectOptions,
      tiposLancamento,
    ],
  );

  const handleDeleteFilters = React.useCallback(
    async (empresaId, idFiltro) => {
      await backendDelete(
        `${v2}/relatorio/${empresaId}/filtros-predefinidos/${idFiltro}`,
      )
        .then(() => {
          showNotification({
            message: 'Filtro predefinido excluído com sucesso!',
            color: 'confirmation',
          });
          updateListaFiltros();
          setfiltroPredefinidoSelected([]);
        })
        .catch((error) => {
          showNotification({
            message: 'Não foi possível excluir filtro predefinido!',
            color: 'destructive',
            supportMessage: error?.message ?? '',
          });
        })
        .finally(() => {});
    },
    [backendDelete, showNotification, updateListaFiltros],
  );

  const handleModalDelete = React.useCallback(
    () =>
      showModal({
        title: 'Exluir filtros predefinidos',
        size: 'large',
        actions: [
          modalActions.confirmar,
          {
            action: modalActions.desistir,
            type: 'secondary',
            color: BaSeTheme.colors.institucionais.azulSebrae36,
          },
        ],
        onChooseAction: (action) => {
          if (action === modalActions.confirmar) {
            handleDeleteFilters(empresa.id, filtroPredefinidoSelected[0].id);
          }
        },
        content: () => (
          <ExcluirGrid
            texts={['Tem certeza que deseja excluir esse filtro predefinido?']}
          />
        ),
      }),
    [empresa, filtroPredefinidoSelected, handleDeleteFilters, showModal],
  );

  React.useEffect(() => {
    setFiltrosPredefinidos(listaFiltrosPredefinidos);
  }, [listaFiltrosPredefinidos]);

  // Atualizacao da lista de filtros predefinido
  React.useEffect(() => {
    const filtrosPorTipo = [];
    for (let index = 0; index < filtrosPredefinidos?.length; index++) {
      if (
        filtrosPredefinidos[index]?.tipoRelatorio ===
        enumRelatorios?.[tipoRelatorio]
      ) {
        filtrosPorTipo.push(filtrosPredefinidos[index]);
      }
    }

    setFiltrosPredefinidoPorTipo(filtrosPorTipo);
  }, [filtrosPredefinidos, tipoRelatorio]);

  return (
    <BaSeContainer delimitedOnBreakpoint="desktop">
      <NoPrint>
        <Jumbotron
          title="Relatórios"
          complement="Escolha abaixo o relatório que você deseja visualizar da empresa."
        />
        <div style={{ marginTop: 36 }}>
          <BaSeGrid>
            <BaSeGridItem tablet={{ size: 12 }} desktop={{ size: 6 }}>
              <BaSeOptionPicker
                withFilterText={false}
                color="default"
                emptyValueLabel="Selecione"
                label="Tipo de relatório"
                size="medium"
                maxOptionsSelected={1}
                onChange={handleTipoRelatorio}
                values={listaTiposRelatorio}
                initialSelectedValuesId={[tipoRelatorio]}
              />
            </BaSeGridItem>
            {tipoRelatorio === typeReport.MENSALMEI && (
              <BaSeGridItem tablet={{ size: 12 }} desktop={{ size: 2 }}>
                <BaSeOptionPicker
                  withFilterText={false}
                  color="default"
                  emptyValueLabel="Selecione"
                  label="Mês"
                  size="medium"
                  maxOptionsSelected={1}
                  onChange={(e) =>
                    setFiltroMeses(e ? months.indexOf(e?.[0]?.id) : null)
                  }
                  values={meses}
                  initialSelectedValuesId={[months[mesAnoAtual?.mes]]}
                />
              </BaSeGridItem>
            )}
            {(tipoRelatorio === typeReport.DASNMEI ||
              tipoRelatorio === typeReport.MENSALMEI) && (
              <BaSeGridItem tablet={{ size: 12 }} desktop={{ size: 2 }}>
                <BaSeOptionPicker
                  withFilterText={false}
                  color="default"
                  emptyValueLabel="Selecione"
                  label="Ano"
                  size="medium"
                  maxOptionsSelected={1}
                  onChange={(e) => setFiltroAnos(e?.[0]?.id ?? null)}
                  values={anos}
                  initialSelectedValuesId={[anos[0].id]}
                />
              </BaSeGridItem>
            )}

            {isAllFilters && (
              <>
                <BaSeGridItem desktop={{ size: 2 }} tablet={{ size: 12 }}>
                  <BaSeSelect
                    onChange={handleChangeMonth}
                    selectedValueId={getSelectCorrectId('id', 3)}
                    values={selectOptions}
                    label="Período do relatório"
                  />
                </BaSeGridItem>
                <BaSeGridItem
                  desktop={{ size: 2 }}
                  tablet={{ size: 6 }}
                  mobile={{ size: 6 }}
                >
                  <BaSeDatePicker
                    label="Data de início"
                    minDate={
                      !isAllFilters && endDate
                        ? sub(endDate, { years: 1 })
                        : undefined
                    }
                    startDate={startDate}
                    onStartDateChange={(date) => {
                      updateProperSelection(setStartDate, date);
                    }}
                    onSelect={(date) => {
                      if (!!date && isAfter(date, endDate)) {
                        updateProperSelection(setEndDate, undefined);
                      }
                    }}
                  />
                </BaSeGridItem>
                <BaSeGridItem
                  desktop={{ size: 2 }}
                  tablet={{ size: 6 }}
                  mobile={{ size: 6 }}
                >
                  <BaSeDatePicker
                    label="Data fim"
                    maxDate={
                      !isAllFilters && startDate
                        ? add(startDate, { years: 1 })
                        : undefined
                    }
                    minDate={startDate}
                    startDate={endDate}
                    onStartDateChange={(date) => {
                      updateProperSelection(setEndDate, date);
                    }}
                    onSelect={(date) => {
                      if (
                        !!date &&
                        isBefore(date, startDate) &&
                        date?.toDateString() !== startDate?.toDateString()
                      ) {
                        updateProperSelection(setStartDate, undefined);
                      }
                    }}
                  />
                </BaSeGridItem>
              </>
            )}
          </BaSeGrid>
        </div>
        {isAllFilters && (
          <div style={{ margin: '16px 0' }}>
            <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
              Filtros
            </BaSeSmall1>
            <BaSeGrid>
              <BaSeGridItem
                mobile={{ size: filtroPredefinidoSelected.length ? 11 : 12 }}
                desktop={{ size: 4 }}
              >
                <div style={{ marginBottom: 10 }}>
                  <BaSeOptionPicker
                    withFilterText={false}
                    color="default"
                    emptyValueLabel="Filtros predefinidos"
                    maxOptionsSelected={1}
                    maxMenuHeight="100px"
                    size="small"
                    values={filtrosPredefinidoPorTipo}
                    onChange={(values) => {
                      setfiltroPredefinidoSelected(values);
                      handleChangeFilters(values);
                    }}
                    initialSelectedValuesId={filtroPredefinidoSelected?.map(
                      (item) => item?.id,
                    )}
                  />
                </div>
              </BaSeGridItem>
              {!!filtroPredefinidoSelected.length && (
                <BaSeGridItem mobile={{ size: 1 }} desktop={{ size: 1 }}>
                  <BaSeShapeButton
                    buttonType="button"
                    color="default"
                    nameIcon="trash-alt"
                    onClick={handleModalDelete}
                    shape="circle"
                    size="medium"
                    sizeIcon="small"
                    type="tertiary"
                  />
                </BaSeGridItem>
              )}
            </BaSeGrid>

            <BaSeGrid>
              {isCategoria && (
                <>
                  {tipoLancamentoFilter} {categoriaFilter} {subcategoriaFilter}
                  {situacaoFilter}
                </>
              )}
              {!isCategoria && (
                <>
                  {(isConta || isDiarioExtratoFluxo) && (
                    <BaSeGridItem
                      tablet={{ size: 12 }}
                      desktop={{ size: isDiarioExtratoFluxo ? 3 : 4 }}
                    >
                      <SelectListTypeReport
                        label="Conta"
                        callBack={handleFiltros}
                        setTypeReport={setListaConta}
                        listReport={listaConta}
                        values={listaContas}
                      />
                    </BaSeGridItem>
                  )}
                  {(isContato || isDiarioExtratoFluxo) && (
                    <BaSeGridItem
                      tablet={{ size: 12 }}
                      desktop={{ size: isDiarioExtratoFluxo ? 3 : 4 }}
                    >
                      <SelectListTypeReport
                        label="Contato"
                        callBack={handleFiltros}
                        setTypeReport={setListaContato}
                        listReport={listaContato}
                        values={listaContatos}
                      />
                    </BaSeGridItem>
                  )}
                  {situacaoFilter} {tipoLancamentoFilter}
                  {categoriaFilter}
                </>
              )}
            </BaSeGrid>
          </div>
        )}
        {isTagsVisible && isAllFilters && (
          <WrapperActivatedFilters isMobile={!inTablet}>
            <div style={{ marginTop: 8, minWidth: 96 }}>
              <BaSeSmall1 isItalic={true} color="#8B99A7">
                Filtros ativados:
              </BaSeSmall1>
            </div>
            <ActivatedFilters>
              {tags.map((tag, index) => {
                if (tag?.todos) {
                  return (
                    <BaSeTag
                      key={`${index}`}
                      label={`${tag?.title}: Todos`}
                      color={BaSeTheme.colors.institucionais.cinzaSebrae30}
                      themeMode="light"
                      onClose={() => {
                        handleRemoveTag(tag);
                      }}
                    />
                  );
                }
                return (
                  tag?.values?.length &&
                  tag?.values?.map((item) => (
                    <BaSeTag
                      key={`${index}-${item?.id}`}
                      label={item?.label}
                      color={BaSeTheme.colors.institucionais.cinzaSebrae30}
                      themeMode="light"
                      onClose={() => handleRemoveTag(item)}
                    />
                  ))
                );
              })}

              <BaSeButton
                size="small"
                type="tertiary"
                color="destructive"
                value="Limpar filtros"
                onClick={handleClearFilters}
              />
              <BaSeButton
                size="small"
                type="tertiary"
                color="default"
                value="Salvar filtros predefinidos"
                onClick={handleNewFilterPredifined}
              />
            </ActivatedFilters>
          </WrapperActivatedFilters>
        )}

        <div style={{ display: 'grid', width: 234, margin: '36px auto' }}>
          <BaSeButton
            isDisabled={loading || tipoRelatorio === 'Selecione'}
            value="Visualizar relatório"
            type="primary"
            onClick={handleVisualizarRelatorio}
          />
        </div>
      </NoPrint>
      <ContentContainer>
        {loading ? (
          <>
            <BaSeLoading
              description=""
              lightMode="default"
              shadowLevel={0}
              spinnerColor=""
              spinnerSize={24}
              text="Carregando…"
              textColor=""
            />
          </>
        ) : error ? (
          <></>
        ) : (
          <>
            {(showRelatorio === typeReport.DASNMEI ||
              showRelatorio === typeReport.MENSALMEI) &&
              !isAllFilters &&
              !isExtrato &&
              !isDiario &&
              !isFluxo && (
                <>
                  <div style={{ marginBottom: 36, display: 'grid', gap: 20 }}>
                    <BaSeMessage
                      color="attention"
                      title="⚠️ Atenção!"
                      message="Guarde junto com esse relatório os documentos fiscais comprobatórios das entradas de mercadorias e serviços tomados referentes ao período."
                    />
                    {message && (
                      <BaSeMessage
                        color="attention"
                        title="⚠️ Atenção!"
                        message={message ?? ''}
                      />
                    )}
                  </div>
                  <RelatoriosMei
                    download={() =>
                      downloadRelatorio(
                        showRelatorio === typeReport.DASNMEI
                          ? relatorioDasnDownload
                          : relatorioMensalMeiDownload,
                        empresa?.id,
                        parseInt(filtroAnos),
                        filtroMeses + 1,
                      )
                    }
                    loadingDownload={loadingDownload}
                    dados={dadosRelatorioMei}
                    tipo={showRelatorio}
                    paramsFilter={[
                      `ano=${parseInt(filtroAnos)}`,
                      `mes=${filtroMeses + 1}`,
                    ]}
                  />
                </>
              )}
            {isAllFilters &&
              dadosRelatorioLancamento &&
              handleShowTable(
                isCategoria
                  ? !!dadosRelatorioLancamento?.listaPorTipoLancamento?.[0]
                      ?.listaCategorias?.length ||
                      !!dadosRelatorioLancamento?.listaPorTipoLancamento?.[1]
                        ?.listaCategorias?.length
                  : checkDadosRelatorio(dadosRelatorioLancamento?.listaPeriodo)
                      ?.length,
                () => (
                  <RelatoriosLancamentos
                    lancamentosRelatorio={dadosRelatorioLancamento}
                    nomeRelatorio={showRelatorio}
                    startDateBroken={!isFirstDayOfMonth(startDate)}
                    endDateBroken={!isLastDayOfMonth(endDate)}
                    typeReport={typeReport}
                    paramsFilter={paramsFilter}
                  />
                ),
              )}
            {isDiario &&
              dadosDiario &&
              handleShowTable(dadosDiario?.lancamentos?.length, () => (
                <RelatorioDiarioLista
                  dados={dadosDiario?.lancamentos}
                  totalDespesa={dadosDiario?.totalDespesas}
                  totalReceita={dadosDiario?.totalReceitas}
                  original={dadosDiario}
                  download={() =>
                    downloadRelatorio(
                      downloadRelatorioDia,
                      empresa?.cnpj,
                      formatdate(startDate),
                      formatdate(endDate),
                    )
                  }
                  loadingDownload={loadingDownload}
                  paramsFilter={paramsFilter}
                />
              ))}
            {isExtrato &&
              dadosExtrato &&
              handleShowTable(dadosExtrato?.lancamentos?.length, () => (
                <RelatorioExtratoLista
                  lancamentos={dadosExtrato?.lancamentos}
                  saldoAnterior={dadosExtrato?.saldoAnterior}
                  totalReceitas={dadosExtrato?.totalReceitas}
                  totalDespesas={dadosExtrato?.totalDespesas}
                  saldoPeriodo={dadosExtrato?.saldoPeriodo}
                  saldoFinal={dadosExtrato?.saldoFinal}
                  download={() =>
                    downloadRelatorio(
                      downloadRelatorioExtrato,
                      empresa?.cnpj,
                      formatdate(startDate),
                      formatdate(endDate),
                    )
                  }
                  loadingDownload={loadingDownload}
                  paramsFilter={paramsFilter}
                />
              ))}
            {isFluxo &&
              dadosFluxo &&
              handleShowTable(dadosFluxo?.lancamentos?.length, () => (
                <RelatorioFluxoLista
                  download={() =>
                    downloadRelatorio(
                      downloadRelatorioFluxo,
                      empresa?.cnpj,
                      formatdate(startDate),
                      formatdate(endDate),
                    )
                  }
                  loadingDownload={loadingDownload}
                  lancamentos={dadosFluxo}
                  startDateBroken={!isFirstDayOfMonth(startDate)}
                  endDateBroken={!isLastDayOfMonth(endDate)}
                  paramsFilter={paramsFilter}
                  mensal={differenceInDays(endDate, startDate) > 31}
                />
              ))}
          </>
        )}
      </ContentContainer>
      <div style={{ display: 'none', position: 'absolute' }}>
        <a
          download={`${empresa?.cnpj} - ${showRelatorio}.pdf`}
          href={blobPdf}
          alt="baixar pdf dos relatórios"
          ref={downloadRef}
        >
          .
        </a>
      </div>
    </BaSeContainer>
  );
};

export default NewRelatoriosPage;
